import React, { useEffect } from "react";
import dronerepaire_image from "../../assets/image/png/EntrepreneurHeroImage.png";

const WhyNewDrone = () => {
  useEffect(() => {
    const slider = document.querySelector(".timeline-slider");
    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const handleMouseUp = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; // Scroll-fast
      slider.scrollLeft = scrollLeft - walk;
    };

    slider.addEventListener("mousedown", handleMouseDown);
    slider.addEventListener("mouseleave", handleMouseLeave);
    slider.addEventListener("mouseup", handleMouseUp);
    slider.addEventListener("mousemove", handleMouseMove);

    return () => {
      slider.removeEventListener("mousedown", handleMouseDown);
      slider.removeEventListener("mouseleave", handleMouseLeave);
      slider.removeEventListener("mouseup", handleMouseUp);
      slider.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div className="container" style={{ padding: "0 15px" }}>
      {/* Timeline */}
      <h5
        className="fs_24 ff_raleway fw-bold mb-0 mt-4 py-5 bg-white"
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          padding: "20px 0",
          marginTop: "20px",
        }}
      >
        Journey of a Drone Entrepreneur
      </h5>
      <div
        className="timeline-slider bg-white"
        style={{
          paddingBottom: "20px",
          overflowX: "scroll",
          display: "flex",
          flexDirection: "row",
          gap: "20px",
        }}
      >
        {[
          {
            step: "Step 1",
            title: "Join Drone Pilot Training",
            description:
              "Become a certified drone pilot with our expert training.",
          },
          {
            step: "Step 2",
            title: "Start Your Own Drone Business",
            description:
              "Purchase a drone and offer services like spraying and seeding.",
          },
          {
            step: "Step 3",
            title: "Expand as a Drone Distributor",
            description:
              "Grow your business by distributing drones and accessories.",
          },
          {
            step: "Step 4",
            title: "Provide RPTO Assistance",
            description:
              "Help others set up Remote Pilot Training Organizations.",
          },
          {
            step: "Step 5",
            title: "Power Platform Details",
            description:
              "Scale your business with comprehensive drone solutions.",
          },
        ].map((item, index) => (
          <div
            key={index}
            className="timeline-item"
            style={{
              minWidth: "250px",
              padding: "15px",
              border: "1px solid #ccc",
              borderRadius: "8px",
            }}
          >
            <div
              className="timeline-step"
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <span
                className="step-count"
                style={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  backgroundColor: "#007bff",
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "10px",
                }}
              >
                {item.step.slice(-1)}
              </span>
              <span style={{ fontSize: "18px", fontWeight: "600" }}>
                {item.title}
              </span>
            </div>
            <p style={{ fontSize: "14px", color: "#555" }}>{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyNewDrone;

